import React, { useMemo } from 'react'
import { useDiscountForm } from '../hooks/useDiscountForm'
import GenericCustomerEligibility from 'src/components/common/customer-eligibility/GenericCustomerEligibility'
import { CustomerEligibilityStateType } from 'src/lib/types/common/customerConditions'
import {
  discountToGenericState,
  genericToDiscountState,
  DISCOUNT_ALLOWED_ELIGIBILITY_OPTIONS
} from 'src/lib/utils/discounts/customerEligibilityConverters'
import FormErrorText from 'src/components/common/FormErrorText'

const CUSTOMER_ELIGIBILITY_ERROR_PATHS = [
  'prerequisite.customerEligibility.prerequisiteUserOrderCohort.lifetimeMinOrderCount',
  'prerequisite.customerEligibility.prerequisiteUserOrderCohort.lifetimeMaxOrderCount',
  'prerequisite.customerEligibility.fileMeta',
  'prerequisite.customerEligibility.segmentIds',
  'prerequisite.customerEligibility.utmParams'
]

const CustomerDiscountEligibilityV2 = () => {
  const { state, actions } = useDiscountForm()
  const { prerequisite } = state
  const { customerEligibility: eligibility } = prerequisite

  const genericState = useMemo(() => discountToGenericState(eligibility), [eligibility])

  const handleChange = (newGenericState: CustomerEligibilityStateType) => {
    const newDiscountState = genericToDiscountState(newGenericState)
    actions.setFormState(
      {
        prerequisite: {
          ...prerequisite,
          customerEligibility: newDiscountState
        }
      },
      CUSTOMER_ELIGIBILITY_ERROR_PATHS
    )
  }

  const errorMessage = CUSTOMER_ELIGIBILITY_ERROR_PATHS.map(path => state.errors[path]).find(Boolean)

  return (
    <div>
      <div className=''>
        <GenericCustomerEligibility
          state={genericState}
          onChange={handleChange}
          allowedOptions={DISCOUNT_ALLOWED_ELIGIBILITY_OPTIONS}
          config={{
            contentClassNames: 'ml-3'
          }}
        />
      </div>
      <div className='px-3'>
        <FormErrorText message={errorMessage} />
      </div>
    </div>
  )
}

export default CustomerDiscountEligibilityV2
